import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { AuthService } from './services/auth/auth.service';
import { DataService } from './services/data/data.service';
import { SplashScreen } from '@capacitor/splash-screen';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private storage:Storage,
    private authService:AuthService,
    private dataService:DataService
  ) {
    this.initializeApp();
  }


  async initializeApp() {
    await this.storage.create();
    await this.platform.ready()
    await this.checkMulti()
    this.dataService.multi ? this.navCtrl.navigateRoot('/multi') : this.navCtrl.navigateRoot('/')
    await this.checkUser();
    if (Capacitor.getPlatform() != 'web') await this.setDefaultStatusBar();
    await SplashScreen.hide();
  }

  async setDefaultStatusBar() {
    await StatusBar.setStyle({ style: Style.Light })
    if (this.platform.is("android")) {
      await StatusBar.setBackgroundColor({ color: "#FFFFFF" })
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  }

  async checkUser() {
    const user = await this.storage.get('user');
    if(user) await this.authService.userStatus();
  }

  async checkMulti() {
    return await new Promise((resolve) => {
      this.dataService.getData(`/multi`)
        .subscribe((res:any) => {
          this.dataService.setMulti(res);
          resolve(true);
        },err => {
          resolve(false)
        })
    })
  }
}
